export const createAccount = (account) => {
    console.log("set account: " + JSON.stringify(account))
    return {
        type: "CREATE_ACCOUNT",
        payload: account
    };
};

export const updateAccount = (account) => {
    return {
        type: "UPDATE_ACCOUNT",
        payload: account
    };
};

